import { render, staticRenderFns } from "./StatusSelectComponent.vue?vue&type=template&id=0d145c6c"
import script from "./StatusSelectComponent.vue?vue&type=script&lang=js"
export * from "./StatusSelectComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports